import { IconButton } from '@scaleaq/scaleui';
import styled from 'styled-components';

import { colors, responsive } from '@/utils';

/** Circular overlay control shown while the camera widget is hovered. */
export const StyledCameraStreamControlButton = styled(IconButton)`
  border-radius: ${responsive.radius.rounded};
  background-color: ${colors.background.neutral.soft[300]};

  /* reset.css colors every svg with CSS, which beats the icon's own color attribute. */
  svg {
    color: ${colors.icon.action[100]};
  }
`;
